import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Icon from '../Icon';

const getSelectedValue = (selectOptions) => {
  const selectedOption = selectOptions.find(selectOption => selectOption.isSelected === true) || {};
  return selectedOption.value;
};

const Select = ({
  selectOptions,
  style,
  selectError,
  extraClass,
  ariaLabel,
  chevronIconSrc,
  selectActive,
  dataTrackable,
  dataClickTracking,
  onChange = () => {},
}) => {
  const selectCssClass = classNames('select', {
    [`select--${style}`]: style,
    'select--error': selectError,
    'select--active': selectActive,
    [`${extraClass}`]: extraClass,
  });

  const options = selectOptions.map(opt => <option key={uuid()} value={opt.value}>{opt.name}</option>);

  return (
    <Fragment>
      <div className="select-wrapper">
        <select
          className={selectCssClass}
          onChange={e => onChange(e.target.value)}
          value={getSelectedValue(selectOptions)}
          aria-label={ariaLabel}
          data-trackable={dataTrackable}
          data-click-tracking={dataClickTracking}
        >
          {options}
        </select>
        <Icon iconExtraClass="select__chevron" iconSrc={chevronIconSrc} />
      </div>
      {selectError && <small>Error!!</small>}
    </Fragment>
  );
};

Select.propTypes = {
  selectOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: PropTypes.string,
  selectError: PropTypes.bool,
  selectActive: PropTypes.bool,
  extraClass: PropTypes.string,
  ariaLabel: PropTypes.string,
  chevronIconSrc: PropTypes.string,
  onChange: PropTypes.func,
  dataTrackable: PropTypes.string,
  dataClickTracking: PropTypes.string,
};


export default Select;
